import { render, staticRenderFns } from "./ProfileAreaWrapper.vue?vue&type=template&id=1c93f480&"
import script from "./ProfileAreaWrapper.vue?vue&type=script&lang=js&"
export * from "./ProfileAreaWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAreaWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports